export default __webpack_public_path__ + "static/media/logo.cd71232f.png";